import { useLanguage } from '../../../contexts/LanguageContext';
import RegisterLink from '../../../components/RegisterLink';
import { FEATURED_BONUSES } from '../../../constants/bonuses';
import { LinkedText } from '../../../components/LinkedText';
import monthlyCompetitionDepositRanking from '../../../assets/monthly-competition-deposit-ranking.jpg';

export default function BonusSection() {
  const { t } = useLanguage();

  return (
    <section
      id="exclusive-bonuses-promotions"
      style={{ background: 'linear-gradient(135deg, #0d0101 0%, #180303 50%, #0d0101 100%)' }}
      className="py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Top badge */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-[#d4a017]/10 border border-[#d4a017]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-gift-fill text-[#d4a017] text-xs" />
            </span>
            <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">
              {t('Bonuses & Rewards', 'Bonus & Ganjaran')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            {t('Exclusive', 'Eksklusif')}{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(135deg, #d4a017, #f5c518)' }}
            >
              {t('Bonuses & Promotions', 'Bonus & Promosi')}
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm leading-relaxed">
            <LinkedText>{t(
              'MrCuci rewards every Malaysian player — from your very first deposit all the way to VIP status. Our promotions are designed to maximise your winning potential.',
              'MrCuci memberi ganjaran kepada setiap pemain Malaysia — dari deposit pertama anda hingga ke status VIP. Promosi kami direka untuk memaksimumkan potensi kemenangan anda.'
            )}</LinkedText>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 md:gap-12 items-center">
          {/* Left: bonus cards */}
          <div className="space-y-3">
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              <LinkedText>{t(
                'Unlock incredible value with our range of casino bonuses crafted for both new and loyal Malaysian players. All bonuses paid in Ringgit with quick processing.',
                'Buka kunci nilai luar biasa dengan pelbagai bonus kasino kami yang direka untuk pemain Malaysia baru dan setia. Semua bonus dibayar dalam Ringgit dengan pemprosesan pantas.'
              )}</LinkedText>
            </p>

            {FEATURED_BONUSES.map((item) => (
              <div
                key={item.id}
                className="flex gap-4 items-start rounded-xl p-4 border border-[#d4a017]/15 hover:border-[#d4a017]/35 transition-all duration-300 group"
                style={{ background: 'linear-gradient(135deg, #1e0404, #250505)' }}
              >
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-lg shrink-0 group-hover:scale-110 transition-transform"
                  style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
                >
                  <i className={`${item.icon} text-black text-lg`} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <h3 className="text-white font-bold text-sm">{t(item.en_title, item.bm_title)}</h3>
                    <span
                      className="text-xs font-black px-2 py-0.5 rounded-full shrink-0"
                      style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)', color: 'black' }}
                    >
                      {item.highlight}
                    </span>
                  </div>
                  <p className="text-gray-500 text-xs leading-relaxed"><LinkedText>{t(item.en_desc, item.bm_desc)}</LinkedText></p>
                </div>
              </div>
            ))}

            <div className="pt-4">
              <RegisterLink
                source="bonus_section_explore_all"
                label={t('Explore All Bonuses', 'Terokai Semua Bonus')}
                className="inline-flex items-center gap-2 font-bold px-7 py-3 rounded-lg hover:opacity-90 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm shadow-[0_4px_16px_rgba(204,17,0,0.35)]"
                style={{ background: 'linear-gradient(135deg, #cc1100, #ff2200)', color: 'white' }}
              >
                <span>{t('Explore All Bonuses', 'Terokai Semua Bonus')}</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </RegisterLink>
            </div>
          </div>

          {/* Right: image with decorative frame */}
          <div className="flex justify-center">
            <div className="relative w-full max-w-md">
              <div className="relative rounded-2xl overflow-hidden">
                <RegisterLink source="bonus_section_monthly_competition_banner" className="cursor-pointer block">
                  <img
                    src={monthlyCompetitionDepositRanking}
                    alt={t(
                      'MrCuci Monthly Competition Deposit Ranking — First RM1088, Second RM888, Third RM588',
                      'Pertandingan Bulanan Kedudukan Deposit MrCuci — Pertama RM1088, Kedua RM888, Ketiga RM588'
                    )}
                    className="w-full h-auto object-cover object-top"
                  />
                </RegisterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
